import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

// Public Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import PricingPage from "./pages/PricingPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

// Teacher Pages
import DashboardPage from "./pages/DashboardPage";
import CreateQuizPage from "./pages/CreateQuizPage";
import PracticeSheetsPage from "./pages/PracticeSheetsPage";
import QuizReviewPage from "./pages/QuizReviewPage";
import QuizLibraryPage from "./pages/QuizLibraryPage";
import StudentsPage from "./pages/StudentsPage";
import AssignmentsPage from "./pages/AssignmentsPage";
import GradingPage from "./pages/GradingPage";
import GradeAttemptPage from "./pages/GradeAttemptPage";
import SubscriptionSuccessPage from "./pages/SubscriptionSuccessPage";

// Grades Pages
import GradesPage from "./pages/GradesPage";
import StudentGradesPage from "./pages/StudentGradesPage";
import ReportCardPage from "./pages/ReportCardPage";
import TranscriptPage from "./pages/TranscriptPage";

// Admin Pages
import AdminDashboard from "./pages/AdminDashboard";

// Student Pages
import StudentLoginPage from "./pages/StudentLoginPage";
import StudentDashboard from "./pages/StudentDashboard";
import StudentQuizTake from "./pages/StudentQuizTake";
import StudentResults from "./pages/StudentResults";

import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          
          {/* Student Routes */}
          <Route path="/student/login" element={<StudentLoginPage />} />
          <Route path="/student/dashboard" element={<StudentDashboard />} />
          <Route path="/student/take/:assignmentId" element={<StudentQuizTake />} />
          <Route path="/student/quiz/:assignmentId" element={<StudentQuizTake />} />
          <Route path="/student/results/:attemptId" element={<StudentResults />} />
          
          {/* Teacher Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/create"
            element={
              <ProtectedRoute>
                <CreateQuizPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/practice-sheets"
            element={
              <ProtectedRoute>
                <PracticeSheetsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz/:quizId"
            element={
              <ProtectedRoute>
                <QuizReviewPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/library"
            element={
              <ProtectedRoute>
                <QuizLibraryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/students"
            element={
              <ProtectedRoute>
                <StudentsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/assignments"
            element={
              <ProtectedRoute>
                <AssignmentsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/grading"
            element={
              <ProtectedRoute>
                <GradingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/grading/:attemptId"
            element={
              <ProtectedRoute>
                <GradeAttemptPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscription/success"
            element={
              <ProtectedRoute>
                <SubscriptionSuccessPage />
              </ProtectedRoute>
            }
          />
          
          {/* Grades Routes */}
          <Route
            path="/grades"
            element={
              <ProtectedRoute>
                <GradesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/grades/:studentId"
            element={
              <ProtectedRoute>
                <StudentGradesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/grades/:studentId/report-card"
            element={
              <ProtectedRoute>
                <ReportCardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/grades/:studentId/transcript"
            element={
              <ProtectedRoute>
                <TranscriptPage />
              </ProtectedRoute>
            }
          />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
